import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormsModule, UntypedFormBuilder} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { DetalleBienCulturalService } from '../../detalle-bien-cultural.service';
import { ActivatedRoute } from '@angular/router';
import { UtilsService } from 'app/modules/utils-service';
import { catchError, from, map, mergeMap, Observable, of, switchMap, toArray } from 'rxjs';
import { ArchivosSubidosInterface } from 'app/models/archivos-subidos-model';
import { SafeResourceUrl } from '@angular/platform-browser';
import { FuseCardComponent } from "../../../../../../../@fuse/components/card/card.component";
import { GaleriaService } from './galeria.service';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'bien-cultural-galeria',
  standalone: true,
  templateUrl: 'galeria.component.html',
  imports: [
    CommonModule, 
    MatIconModule, 
    FuseCardComponent, 
    MatButtonModule, 
    MatFormFieldModule, 
    FormsModule,
    MatInputModule
  ],

})
export class GaleriaComponent implements OnInit {
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
  @Input() nombreFotografo:string
  isDraggingOver = false;
  placeholder = '/assets/images/tikal.png';
  uu_id:string
  imagenesSubidas: { url: string, nombre: string, tamano: number }[] = [];
  archivosGaleria$ :  Observable<ArchivosSubidosInterface[]>
  imageUrl: SafeResourceUrl | null = null;
  archivosGaleria: ArchivosSubidosInterface[] = [];

  fotogragiadoPor: string = '';
  nombreArchivo:string
  nombreArchivoOriginal: string = '';


  constructor(
    private _formBuilder: UntypedFormBuilder,
    private detalleService: DetalleBienCulturalService,
    private route:ActivatedRoute,
    private utilsService: UtilsService,
    private galeriService:GaleriaService
  ) {

    this.uu_id = this.route.snapshot.paramMap.get('uu_id')!;
    this.archivosGaleria$ = this.galeriService.archivosGaleria$
    this.fotogragiadoPor='';
    this.nombreArchivo= '123'
  }

  ngOnInit() {this.obtenerGaleria()}

  uploadImage() {
    this.fileInput.nativeElement.click();
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDraggingOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDraggingOver = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    this.isDraggingOver = false;
    if (event.dataTransfer?.files.length > 0) {
      this.handleFiles(event.dataTransfer.files);
      event.dataTransfer.clearData();
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      this.handleFiles(input.files);
      input.value = ''; // para permitir volver a seleccionar el mismo archivo si se desea
    }
  }
  

  handleFiles(files: FileList) {
    const formData = new FormData();
  
    Array.from(files).forEach(file => {
      formData.append('files', file);
    });
  
    this.detalleService.postGaleria(formData, this.uu_id)
      .then((response:any) => {
        const mensaje=  response.message ?? 'Los archivos han sido subidos correctamente.';
        this.utilsService.openSuccessSnakBar(mensaje)
        this.obtenerGaleria();
        this.detalleService.getBitacoraBienes(this.uu_id)
      })
      .catch(error => {
        this.utilsService.openSuccessSnakBar(error)
      });
  }

  fotografiadoPor(){
    const formData = new FormData();
    formData.append('fotografiaPor', this.fotogragiadoPor); 
    this.detalleService.postGaleria(formData, this.uu_id)
    .then((response:any)=>{
      this.detalleService.getFichaRegistro(this.uu_id)
      this.utilsService.openSuccessSnakBar(response.message)
      this.fotogragiadoPor= ''
    })
  }

  removeImage(uu_id_archivo: number) {
    this.utilsService.open_confirm_dialog(`Esta seguro que desea eliminar la fotografía`, 'Eliminar Fotografía')
            .subscribe(response => {
                if (response === 'confirmed') {
                     this.galeriService.eliminarArchivo(uu_id_archivo)
                        .then(() => {
                          this.obtenerGaleria()
                          this.utilsService.openSuccessSnakBar('Archivo ha sido eliminado correctamente.')
                        });
                }
            })
  }

  archivoFavorito(uu_id_archivo:number){
    this.galeriService.putArchivoFavorito(this.uu_id, uu_id_archivo)
      .then((response:any)=>{
        this.obtenerGaleria()
        this.detalleService.getFichaRegistro(this.uu_id)
      })
  }

  obtenerGaleria(){
    this.galeriService.getArchivosGaleria(this.uu_id)
  }

  //Guardar el valor original del nombre de la imagen
  guardarOriginal(img: any) {
    img._nombreArchivoOriginal = img.nombreArchivo;
  }

  //Verificar si cambió y actualiza el nombre de la imagen
  actualizarNombreSiCambio(img: any) {
    if (img.nombreArchivo !== img._nombreArchivoOriginal) {
      this.galeriService.actualizarNombreImagen(img.nombreArchivo, img.archivoId)
        .then((response: any) => {
          this.utilsService.openSuccessSnakBar(response.message);
        });
    }
  }

}
